@if (showMarketHelp) {
    <ms-market-help [optionGroup]="optionGroup" [eventHelpText]="eventHelpText" />
}
<div class="option-group-container score-market-container" [ngClass]="tupleClass" [style.min-height.px]="minContainerHeight">
    <div class="option-group-header">
        <span></span>
        @for (header of optionHeaders; track trackHeader($index, header)) {
            <span class="option-group-custom-header">
                <div>{{ header }}</div>
            </span>
        }
    </div>
    <ng-container *rxFor="let group of optionGroups | slice: 0 : visibleOptionsLimit; trackBy: trackGroup">
        <div class="attribute-key">{{ group[0].marketAttribute }} {{ group[0].optionColumnName }}</div>
        @for (header of optionHeaders; track trackHeader($index, header)) {
            @if (getOption(group, header); as option) {
                <ms-option
                    [tracking]="{ source: tracking, moduleType: trackingModuleType }"
                    [option]="option"
                    [optionGroup]="optionGroup"
                    [event]="event"
                    [showOptionName]="false"
                    [showPromoBadge]="!!crmPromoIdsMap.options[option.id]"
                    [sourceOfPick]="sourceOfPick"
                    [betDetails]="betDetails" />
            }
        }
    </ng-container>
</div>

@if (showMoreLessButtonVisible) {
    <div class="show-more-less-button" [class.expanded]="expanded" (click)="onShowMoreLessButtonToggle()">
        {{ expanded ? sitecore.event.ShowLess : sitecore.event.ShowMore }} <vn-icon name="theme-right" size="12" class="right-icon" />
    </div>
}
